import { lazy } from 'react'
import { useIntersectionObserver } from 'usehooks-ts'

const LazyLottie = lazy(() => import('./lottie'))
import ShieldLoader from '../ui/shield-loader'
import type { LottieProps } from './lottie'

export default function Lottie(props: LottieProps) {
  const src = props.animationData || props.lottieFile?.fields?.file?.url || props.lottieFile?.file?.url

  const { isIntersecting, ref } = useIntersectionObserver({
    rootMargin: '200px',
    freezeOnceVisible: true,
  })

  if (!src) return null

  return <div ref={ref}>{isIntersecting ? <LazyLottie {...props} /> : <ShieldLoader />}</div>
}
